import { Modal, Form, Input, Button } from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import globalRequest from "../../utils/global/globalRequest";
import toast from "react-hot-toast";
import * as Apis from "../../utils/helper/enum";
import { changeLoader } from "../../redux/reducers/loader";

const SettlePayout = ({ isOpen, onCancel, onOk, type, payoutData }) => {
  const dispatch = useDispatch();
  const [payout, setPayout] = useState([]);
  const [userType, setUserType] = useState("");

  const [form] = Form.useForm();

  useEffect(() => {
    setPayout(payoutData);
    setUserType(type);
  }, [payoutData, type]);

  const handleInputChange = (key, value) => {
    form.setFieldValue(key, value.trimStart());
  };

  const handleSubmit = async (values) => {
    dispatch(changeLoader(true));
    try {
      let url = Apis?.MANAGE_DRIVERS_PAYOUT?.PAYOUT_MARK_SETTLED + "/" + payout.id;
      if (userType === "vendor") url = Apis?.MANAGE_VENDOR_PAYOUT?.PAYOUT_MARK_SETTLED + "/" + payout.id;
      let method = "post";
      let response = await globalRequest(url, method, values, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Payout settled successfully";
        toast.success(msg, {
          duration: 2000,
        });
        onOk();
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  return (
    <>
      <Modal title="Settle Payout" centered open={isOpen} onCancel={onCancel} width={500} okText="Yes" cancelText="No" footer={[]}>
        <div className="flex flex-col gap-2 mb-2">
          <div className="text-base">
            {userType === "driver" ? "Driver Name : " : "Vednor Name : "}
            <span className="text-gray-200 text-base">
              {payoutData?.user?.firstName} {payoutData?.user?.lastName}
            </span>
          </div>
          <h1 className="text-base">Bank Detail:</h1>
          <div className="flex flex-col gap-2">
            <div className="text-base">
              Benificiory name :{" "}
              <span className="text-gray-200 text-base">
                {userType === "driver"
                  ? payoutData?.user?.driverPayoutDetail?.beneficiaryName
                  : payoutData?.user?.vendorPayoutDetail?.beneficiaryName}
              </span>
            </div>
            {userType === "driver" ? (
              <div className="text-base">
                Account Number :{" "}
                <span className="text-gray-200 text-base">
                  {userType === "driver"
                    ? payoutData?.user?.driverPayoutDetail?.accountNumber
                    : payoutData?.user?.vendorPayoutDetail?.accountNumber}
                </span>
              </div>
            ) : null}
            <div className="text-base">
              IBAN :{" "}
              <span className="text-gray-200 text-base">
                {userType === "driver" ? payoutData?.user?.driverPayoutDetail?.IBAN : payoutData?.user?.vendorPayoutDetail?.IBAN}
              </span>
            </div>
            {userType !== "driver" ? (
              <div className="text-base">
                Swift Code :{" "}
                <span className="text-gray-200 text-base">
                  {userType === "driver"
                    ? payoutData?.user?.driverPayoutDetail?.swiftCode
                    : payoutData?.user?.vendorPayoutDetail?.swiftCode}
                </span>
              </div>
            ) : null}
          </div>
        </div>
        <Form form={form} name="Settle Payout" layout="vertical" autoComplete="off" onFinish={handleSubmit}>
          <Form.Item
            name="payout_amount"
            label="Payout Amount"
            rules={[
              {
                required: true,
                message: "Please enter your amount.",
              },
              {
                validator: (_, value) =>
                  !value || /^\d+(\.\d{1,2})?$/.test(value)
                    ? Promise.resolve()
                    : Promise.reject(new Error("Only numeric values (up to 2 decimal places) are allowed.")),
              },
            ]}
          >
            <Input
              size="large"
              onChange={(e) => {
                handleInputChange("payout_amount", e.target.value);
              }}
            />
          </Form.Item>
          <Form.Item
            name="payout_notes"
            label={`Add any notes and transaction details`}
            rules={[
              {
                required: true,
                message: "Please enter your amount.",
              },
              {
                max: 150,
                message: "Maximum 150 characters",
              },
            ]}
          >
            <Input
              size="large"
              onChange={(e) => {
                handleInputChange("payout_notes", e.target.value);
              }}
            />
            {/* <span className="text-[#ff4d4f]">Please Enter detail here</span> */}
          </Form.Item>
          <div className="flex justify-between items-center">
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              Yes
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default SettlePayout;
